import React, { memo } from "react";
import Form from "react-bootstrap/Form";

function Search({setsearch}) {
    const handlechange=(e)=>{
        setsearch(e.target.value)

    }
  return (
    <div>
      {" "}
      <Form.Group>
        <Form.Control   onChange={handlechange} type="search" placeholder="Search.." />
      </Form.Group>
    </div>
  );
}

export default memo(Search);
